import { render, staticRenderFns } from "./Editr.vue?vue&type=template&id=2a624410&lang=pug&"
import script from "./Editr.vue?vue&type=script&lang=js&"
export * from "./Editr.vue?vue&type=script&lang=js&"
import style0 from "./Editr.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports